import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAutenticacao } from "@/contextos/AutenticacaoContexto";
import { ShieldCheck } from "lucide-react";
import { ConteudoRegulamento } from "@/componentes/ConteudoRegulamento";

export default function AceitarRegulamento() {
  const { usuario, aceitarRegulamento, sair } = useAutenticacao();
  const navigate = useNavigate();
  const [aceitou, setAceitou] = useState(false);
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);

  if (usuario?.regulamentoAceito) {
    navigate("/dashboard", { replace: true });
    return null;
  }

  const submeter = async () => {
    if (!aceitou) {
      setErro("Você precisa marcar o aceite para continuar.");
      return;
    }
    setEnviando(true);
    setErro("");
    try {
      await aceitarRegulamento("1.0");
      navigate("/dashboard", { replace: true });
    } catch (e) {
      setErro(e.response?.data?.detail || "Erro ao aceitar regulamento");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="min-h-screen bg-superficie-base text-white py-12 px-6" data-testid="pagina-aceite-regulamento">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <ShieldCheck className="w-6 h-6 text-amarelobrasil" />
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-amarelobrasil">Aceite Obrigatório</span>
        </div>
        <h1 className="font-heading uppercase text-4xl font-bold mb-2">Regulamento Oficial</h1>
        <p className="text-white/60 mb-8">
          Para acessar o sistema você precisa ler e aceitar o regulamento abaixo.
        </p>

        <div className="surface-card rounded-2xl p-6 md:p-8 max-h-[480px] overflow-y-auto" data-testid="conteudo-regulamento">
          <ConteudoRegulamento />
        </div>

        <label className="flex items-center gap-3 mt-6 cursor-pointer" data-testid="label-checkbox-aceite">
          <input
            type="checkbox"
            checked={aceitou}
            onChange={(e) => setAceitou(e.target.checked)}
            className="w-5 h-5 accent-verdebrasil"
            data-testid="checkbox-aceitar-regulamento"
          />
          <span className="text-sm">Li e aceito integralmente o regulamento acima.</span>
        </label>

        {erro && (
          <div className="mt-4 text-sm text-red-400 bg-red-500/10 border border-red-500/20 px-3 py-2 rounded-md" data-testid="msg-erro-aceite">
            {erro}
          </div>
        )}

        <div className="flex gap-3 mt-6">
          <button
            onClick={submeter}
            disabled={!aceitou || enviando}
            className="px-8 py-3 rounded-md font-heading uppercase tracking-widest text-sm bg-verdebrasil hover:bg-verdebrasil-dark transition-all hover:glow-green disabled:opacity-50"
            data-testid="btn-confirmar-aceite"
          >
            {enviando ? "Salvando..." : "Aceitar e Continuar"}
          </button>
          <button
            onClick={() => { sair(); navigate("/login"); }}
            className="px-8 py-3 rounded-md font-heading uppercase tracking-widest text-sm text-white/60 hover:text-white border border-white/10 transition-all"
            data-testid="btn-recusar-sair"
          >
            Recusar e Sair
          </button>
        </div>
      </div>
    </div>
  );
}
